import { Row, Col, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionIdiomaSede({ formik, formationCenter, userOU, idCedesca, idCntec }) {
  return (
    <Row>
      <Col md="2">
        <Label htmlFor="idioma">
          <small>
            Idioma <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="idioma"
          name="idioma"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.idioma}
          className={formik.errors.idioma ? 'border border-danger error rounded ' : ''}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        >
          <option key="0-idioma" value=""></option>
          <option key="1-idioma" value="Español">Español</option>
          <option key="2-idioma" value="Catalán">Catalán</option>
        </Input>
        {formik.errors.idioma ? (
          <div className="text-danger tiny">{formik.errors.idioma}</div>
        ) : null}
      </Col>
      <Col md="2">
        <Label htmlFor="idalu">
          <small>IDALU</small>
        </Label>
        <Input
          id="idalu"
          name="idalu"
          type="text"
          onChange={(e) => {
            const value = e.target.value.replace(/\s+/g, '');
            formik.setFieldValue('idalu', value);
          }}
          value={formik.values.idalu}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        />
      </Col>
      <Col md="3">
        <Label htmlFor="sede">
          <small>
            Sede examen <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="sede"
          name="sede"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.sede}
          disabled={(idCedesca > 0 && idCntec > 0) || userOU.centro === 'ORIENTACIÓN'}
          className={formik.errors.sede ? 'border border-danger error rounded ' : ''}
        >
          {formationCenter !== ''
            ? formationCenter.map((option) => (
                <option key={`${option.Id}-sedeExamen`} value={option.Poblacion}>
                  {option.Poblacion}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.sede ? (
          <div className="text-danger tiny">{formik.errors.sede}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="tsi">
          <small>TSI </small>
        </Label>
        <Input
          id="tsi"
          name="tsi"
          type="text"
          value={formik.values.tsi}
          onChange={(e) => {
            const value = e.target.value.replace(/\s+/g, '');
            formik.setFieldValue('tsi', value);
          }}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        />
      </Col>
    </Row>
  );
}

SeccionIdiomaSede.propTypes = {
  formik: PropTypes.object.isRequired,
  formationCenter: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  userOU: PropTypes.object.isRequired,
  idCedesca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idCntec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SeccionIdiomaSede;
